var exports = {
  "n": "FeedPostContent.module__gif___OXhMVX",
};

module.exports = exports;
